import PropTypes from 'prop-types';
import React from 'react';
import AnimatedNaraMark from './AnimatedNaraMark';
import './animation.css';
import './style.css';

export function Loading({ slow = false, startup = true }) {
  return (
    <div className={`nf-fullscreen-loader${slow ? ' is-slow' : ''}`} role="status" aria-live="polite">
      <span className="nf-fullscreen-loader__mark" aria-hidden="true">
        <AnimatedNaraMark startup={startup} />
      </span>
      <div className="nf-fullscreen-loader__copy">
        {slow ? (
          <><strong>A conexão está um pouco lenta</strong><span>Ainda estamos carregando suas informações. Isso pode levar mais alguns instantes.</span></>
        ) : (
          <p>Carregando…</p>
        )}
      </div>
    </div>

  );
}
Loading.propTypes = {
  slow: PropTypes.bool,
  startup: PropTypes.bool,
};
